import Actor from "./Actor";
import common from "../common";

export default class SecondaryCharacter extends Actor {
    /**
     * Initial setup for secondary character. Sets Name, animations
     * @param {string} name
     */
    constructor(name, request, texture) {
        super(texture);

        this._characterName = name;
        this._request = common.randomSelection(request);
        this._requestCompleted = false;
        this._charTexture = texture;
    }

    getName() {
        return this._characterName;
    }

    getRequest(){
        return this._request;
    }

    slideIn(tweens, destination){

    }

    breath(){

    }
}

SecondaryCharacter.BREATH = (tweens, sprite)=>{
    let breathOut = new P3.utils.TWEEN.Tween(sprite.scale, tweens)
        .to({
            x: "+0.03",
            y: "+0.03"
        }, 2000)
        .easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut);
    let breathIn = new P3.utils.TWEEN.Tween(sprite.scale, tweens)
        .to({
            x: "-0.03",
            y: "-0.03"
        }, 2000)
        .easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut);

    breathOut.chain(breathIn);
    breathIn.chain(breathOut);

    return {in: breathIn, out: breathOut};
};
SecondaryCharacter.SLIDE_IN = (tweens, destination, container)=>{
    return new P3.utils.TWEEN.Tween(container, tweens)
        .to({
            x: destination
        }, 750)
        .delay(500)
        .easing(P3.utils.TWEEN.Easing.Quadratic.Out);
};